import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { ConfirmationModalPopupComponent } from 'src/app/core/confirmation-modal-popup/confirmation-modal-popup.component';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityConsoleEquipmentsObject, FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { environment } from 'src/environments/environment';
import { MultiFacilityService } from '../../services/multi-facility.service';
import { SelectionInfo } from './multi-selection.model';

@Component({
  selector: 'app-multi-selection',
  templateUrl: './multi-selection.component.html',
  styleUrls: ['./multi-selection.component.scss'],
})
export class MultiSelectionComponent implements OnInit, OnDestroy {
  @Input() permissionSelectConsole: string;
  @Input() enableEquipmentSelect: boolean = false;
  @Input() enableSmartStrengthSelect = false;
  @Input() disableConsoleSelect: boolean = false;
  @Input() allConsolesEnabled: boolean = false;
  @Output() selectedConsoleEmit: EventEmitter<string> = new EventEmitter<string>();
  @Output() onSelectionChange: EventEmitter<SelectionInfo> = new EventEmitter<SelectionInfo>();
  selectedConsoleSource$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  isSelectedCardioConsole = true;
  isSelectedSmartStrength = false;
  selectedSmartStrength = { activityId: '10001', count: '0' };
  selectedConsoleImage = environment.cloudBasePath + '/Icons/Icon_Radio_Selected_White_S.svg'
  nonSelectedConsoleImage = environment.cloudBasePath + '/Icons/Icon_Radio_Selected_White_S.svg';
  private showConfirmUnsave = false;
  private facilityOnChange: Subscription;
  private facilityOnChange2: Subscription;
  private rootScopeOnChange: Subscription;
  private currentSelection: SelectionInfo = new SelectionInfo();
  private isReloadSelectConsoles: boolean;
  private isReloadSelectEquipment: boolean; 
  private lastSelectedConsole: FacilityConsoleEquipmentsObject;
  private lastSelectedEquipment: string;
  
  @ViewChild(ConfirmationModalPopupComponent) modalComponent: ConfirmationModalPopupComponent;
  
  constructor(
    private commonUtil: CommonUtil,
    private facilityService: FacilityService,
    private multiFacilityService: MultiFacilityService,
    private rootScopeService: RootScopeService) {}

  ngOnInit(): void {
    this.getRootScopeData();
    this.currentSelection.facility = this.facilityService.selectedFacility();
    this.currentSelection.multiFacilities = this.facilityService.selectedMultiFacilities();
    this.currentSelection.consoleType = this.currentSelection.rootScopeData.lastSelectedConsole;
    this.facilityOnChange = this.facilityService.selectedFacilitySource.subscribe((res) => {
      if(this.currentSelection.facility?.facilityId != res.facilityId) {
        setTimeout(() => {
          if(this.facilityService.selectedMultiFacilities().length == 1)
            this.onFacilityChange(res);
        }); 
      }
    });
    this.facilityOnChange2 = this.multiFacilityService.selectedFacilityListSource.subscribe(res => {  
      res = res.slice().sort();
      if(JSON.stringify(this.currentSelection.multiFacilities) !== JSON.stringify(res)) {
        this.currentSelection.multiFacilities = res; 
        // refresh console selector when multi facility are selected
        setTimeout(() => this.isReloadSelectConsoles = true);
      }
        });
  }

  getRootScopeData(): void {
    this.rootScopeOnChange = this.rootScopeService
      .getRootScope()
      .subscribe((rootScopeData) => {
        this.currentSelection.rootScopeData = rootScopeData;
      });
  }

  clickOnSelectCardioConsole(): void {
    this.isSelectedCardioConsole = true;
    this.isSelectedSmartStrength = false;
  }

  clickOnSmartStrengthConsole(): void {
    this.isSelectedCardioConsole = false;
    this.isSelectedSmartStrength = true;
  }

  ngOnDestroy(): void {
    this.facilityOnChange?.unsubscribe();
    this.facilityOnChange2?.unsubscribe();
    this.rootScopeOnChange?.unsubscribe();
  }

  private onFacilityChange(facility: FacilityObject) {
    if(this.currentSelection.facility?.facilityId != facility.facilityId) {
      this.currentSelection.facility = facility;
      setTimeout(() => this.isReloadSelectConsoles = true);
    }
  }

  private onConsoleChange(consoleObj: FacilityConsoleEquipmentsObject) {
    if(!consoleObj) {
      this.commonUtil.redirectToAvailablePage();      
      setTimeout(() => this.isReloadSelectConsoles = false);
      return;
    }
    if(this.isReloadSelectConsoles || this.lastSelectedConsole?.consoleType !== consoleObj.consoleType) {      
      this.currentSelection.consoleType = consoleObj.consoleType;
      this.currentSelection.consoleObj = consoleObj;
      // manually show unsave modal dialog to control the response from user
      if(this.currentSelection.rootScopeData.isPageHasUnsavedChanges && !this.currentSelection.rootScopeData.showUnSavedChangesModal && 
        !this.showConfirmUnsave) { 
        this.showConfirmUnsave = true;
        // allow the current process to end before processing the showing of modal
        setTimeout(() => {            
          this.modalComponent.show(true).then(res => {
            if(res == 1) {// ignore changes
              this.lastSelectedConsole = consoleObj;
              this.currentSelection.rootScopeData.lastSelectedConsole = consoleObj.consoleType;
              this.currentSelection.rootScopeData.isPageHasUnsavedChanges = false;
              // let equipment component to process the new selected console first
              if(!this.enableEquipmentSelect) { 
                this.onSelectionChange.emit(this.currentSelection);
              } else {
                setTimeout(() => this.isReloadSelectEquipment = true);
              }
            } else {
              this.currentSelection.consoleType = this.lastSelectedConsole.consoleType;
              this.currentSelection.consoleObj = this.lastSelectedConsole;
            }
            this.showConfirmUnsave = false;
          });
        });
      } else if(!this.showConfirmUnsave) {
        this.lastSelectedConsole = consoleObj;
        this.currentSelection.rootScopeData.lastSelectedConsole = consoleObj.consoleType;
        // let equipment component to process the new selected console first
        if(!this.enableEquipmentSelect) { 
          this.onSelectionChange.emit(this.currentSelection);
        } else {
          setTimeout(() => this.isReloadSelectEquipment = true);
        }
      }
    }
    setTimeout(() => this.isReloadSelectConsoles = false);
  }

  private onEquipmentChange(activityId: string){
    if(this.isReloadSelectEquipment || this.lastSelectedEquipment !== activityId) {
      this.currentSelection.activityId = activityId;
      if(this.currentSelection.rootScopeData.isPageHasUnsavedChanges && !this.currentSelection.rootScopeData.showUnSavedChangesModal && !this.showConfirmUnsave) {
        this.showConfirmUnsave = true;
        // allow the current process to end before processing the showing of modal
        setTimeout(() => {            
          this.modalComponent.show(true).then(res => {
            if(res == 1) {// ignore changes
              this.lastSelectedEquipment = activityId;
              this.currentSelection.rootScopeData.isPageHasUnsavedChanges = false; 
              this.onSelectionChange.emit(this.currentSelection);
            } else {
              this.currentSelection.activityId = this.lastSelectedEquipment;
            }
            this.showConfirmUnsave = false;
          });
        });
      } else if(!this.showConfirmUnsave) {
        this.lastSelectedEquipment = activityId;
        this.onSelectionChange.emit(this.currentSelection);
      }
    }
    setTimeout(() => this.isReloadSelectEquipment = false);
  }
}
